import { Outlet } from "react-router";
import "./App.css";

function App() {
  return (
    <Outlet />
  );
}

export default App;
